import React, { useState } from "react";

export const HudButton = ({ children, onClick, className = "", variant = "primary", disabled = false }) => {
  const [isHovered, setIsHovered] = useState(false);

  const baseStyles = "relative inline-flex items-center justify-center px-6 py-3 font-mono font-bold transition-all duration-300 group focus:outline-none";
  const interactStyles = "hover:-translate-y-1 hover:drop-shadow-[0_4px_6px_rgba(255,108,0,0.4)] cursor-pointer";
  const disabledStyles = "opacity-50 cursor-not-allowed grayscale";

  const variants = {
    primary: "text-[#FF6C00] hover:text-black",
    secondary: "text-[#FF6C00] hover:text-black",
    ghost: "text-[#FF6C00] hover:text-[#FF8A3D]",
  };

  // Correct Amber Color: #FF6C00
  // Fill: rgba(255, 108, 0, 0.2)
  
  const svgBgStyle = {
    background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox='0 0 100 100'%3E%3Cpolygon points='10,0 100,0 100,70 90,100 0,100 0,30' fill='rgba(255,108,0,0.2)' stroke='%23FF6C00' stroke-width='2' vector-effect='non-scaling-stroke'/%3E%3C/svg%3E")`,
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat"
  };

  const svgBgHoverStyle = {
    background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox='0 0 100 100'%3E%3Cpolygon points='10,0 100,0 100,70 90,100 0,100 0,30' fill='%23FF6C00' stroke='%23FF6C00' stroke-width='2' vector-effect='non-scaling-stroke'/%3E%3C/svg%3E")`,
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat"
  };

  // Determine current style based on state
  const currentStyle = (isHovered && !disabled) ? svgBgHoverStyle : svgBgStyle;

  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`${baseStyles} ${disabled ? disabledStyles : interactStyles} ${variants[variant]} ${className}`}
      style={currentStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className="relative z-10 flex items-center">{children}</span>
    </button>
  );
};
